import { EMPTY_ADD_USER_FORM } from 'Main/Constant'
import { useEffect, useState } from 'react'
import BasicInput from 'views/components/Input/BasicInput'

export function AddUserModal ({ show, submitting, onClose, onSubmit }) {
  const [form, setForm] = useState(EMPTY_ADD_USER_FORM)

  useEffect(() => {
    if (show) setForm(EMPTY_ADD_USER_FORM)
  }, [show])

  if (!show) return null

  const setField = (field) => (value) => {
    setForm((f) => ({ ...f, [field]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(form)
  }

  return (
    <>
      <div className="modal-backdrop fade show" onClick={submitting ? undefined : onClose} />
      <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title">Add User</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={onClose}
                  disabled={submitting}
                />
              </div>

              <div className="modal-body">
                <div className="mb-2">
                  <BasicInput label="Username" value={form.username} onChange={setField('username')} />
                </div>
                <div className="mb-2">
                  <BasicInput label="Email" value={form.email} onChange={setField('email')} />
                </div>
                <div className="mb-2">
                  <BasicInput label="Password" type="password" value={form.password} onChange={setField('password')} />
                </div>
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-light text-black" onClick={onClose} disabled={submitting}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-success" disabled={submitting}>
                  <i className={`fa-solid ${submitting ? 'fa-circle-o-notch fa-spin' : 'fa-user-plus'}`} />{' '}
                  {submitting ? 'Adding...' : 'Add User'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}
